export const crecerStepToEvent = {
  conectar: 'crecerConectar',
  encuentro: 'crecerEncuentro',
  vida: 'crecerVida',
  influencia: 'crecerInfluence',
  bautizo: 'crecerBautizo',
};
